import React from 'react';
import { useUpdateShape } from 'hooks';
import Collapse from './Collapse';
import DayNumberFields from './DayNumberFields';

export const DayStyle = ({ object, toolbarRef }) => {
  const onChange = useUpdateShape(object.id);
  return (
    <Collapse text="Date numbers">
      <DayNumberFields shape={object} onChange={onChange} toolbarRef={toolbarRef} />
    </Collapse>
  );
};

export default DayStyle;
